module.exports = __webpack_public_path__ + "static/media/google.8de3d8cb.jpg";